import { render } from "./MyList.vue?vue&type=template&id=d5f57422&scoped=true&ts=true"
import script from "./MyList.vue?vue&type=script&lang=ts"
export * from "./MyList.vue?vue&type=script&lang=ts"

import "./MyList.vue?vue&type=style&index=0&id=d5f57422&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5f57422"]])

export default __exports__